import { useEffect, useState } from "react";
import api from "@/lib/api";
import DashboardLayout from "@/components/DashboardLayout";
import { Mail, Phone, User } from "lucide-react";

export default function AdminClients() {
  const [clients, setClients] = useState([]);

  useEffect(() => {
    api.get("/clients").then((r) => setClients(r.data)).catch(() => {});
  }, []);

  return (
    <DashboardLayout role="admin" title="Clients" subtitle="Homeowners with active accounts on your portal.">
      {clients.length === 0 ? (
        <div className="card p-12 text-center text-sm" style={{color:'var(--text-muted)'}}>
          No clients have signed up yet. Direct them to your <code>/register</code> page or share their portal link.
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {clients.map((c) => (
            <div key={c.id} className="card p-5" data-testid={`client-card-${c.id}`}>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-full flex items-center justify-center font-display font-bold text-lg" style={{background:'rgba(212,163,115,0.15)', color:'var(--accent)'}}>
                  {c.name.charAt(0).toUpperCase()}
                </div>
                <div className="min-w-0">
                  <div className="font-display font-bold truncate">{c.name}</div>
                  <div className="text-xs" style={{color:'var(--text-muted)'}}>Joined {new Date(c.created_at).toLocaleDateString()}</div>
                </div>
              </div>
              <div className="space-y-1.5 text-sm">
                <a href={`mailto:${c.email}`} className="flex items-center gap-2" style={{color:'var(--text-muted)'}}>
                  <Mail size={13} style={{color:'var(--accent)'}}/> <span className="truncate">{c.email}</span>
                </a>
                {c.phone && (
                  <a href={`tel:${c.phone}`} className="flex items-center gap-2" style={{color:'var(--text-muted)'}}>
                    <Phone size={13} style={{color:'var(--accent)'}}/> {c.phone}
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </DashboardLayout>
  );
}
